<section class="storyblok-blok-container">
  <div
    *ngIf="!isSubsidiaryAccount"
    [ngStyle]="{ 'background-color': colorSelector() }"
    class="advanced-newsletter"
    appIsVisible
    (isVisible)="initializeNewsletterView()"
  >
    <div class="advanced-newsletter__voucher-info">
      <figure>
        <img [appLazyLoadImage]="!color || color === 'white' ? whiteVoucherImage : blueVoucherImage" alt="newsletter" />
        <span
          [ngClass]="{
          'voucher-price-light-blue': !color || color === 'white',
          'voucher-price-primary-blue': color === 'lightBlue'
        }"
        >{{ amount || NLDiscount }}{{ (voucherType === 'percentage' || !voucherType) ? '%' : '€' }}</span
        >
      </figure>
      <div>
        <h3
          [ngClass]="{
          'text-primary-blue': !color || color === 'white',
          'text-white': color === 'lightBlue'
        }"
        >
          {{ title || 'NEWSLETTER_V2_VOUCHER.TITLE' | translate }}
          <span [ngClass]="{ 'text-voucher': !title && (!color || color === 'white') }">{{
              !title ? ('NEWSLETTER_V2_VOUCHER.DISCOUNT' | translate: { discount: NLDiscount }) : ''
            }}</span>
        </h3>
      </div>
    </div>
    <div class="advanced-newsletter__form-content">
      <ng-container *ngIf="!isFormSubmitted; else submitConfirmationTemplate">
        <form class="advanced-newsletter__form-content__form" [formGroup]="form" (submit)="onSubmit()">
          <div class="advanced-newsletter__form-content__form__form-input">
            <mm-field>
              <input
                mmInput
                type="text"
                formControlName="email"
                aria-label="newsletter input for user email addresses"
                placeholder="{{ 'HOME.HOME_PAGE.NEWSLETTER.EMAIL_PLACEHOLDER' | translate }}"
                (focus)="onFocus()"
              />
            </mm-field>
            <mm-error fieldName="email">
              {{ 'CATALOG.DETAILS_PAGE.BUYBOX.OUT_OF_STOCK.VALIDATION' | translate }}
            </mm-error>
          </div>
          <div class="advanced-newsletter__form-content__form__form-button">
            <button
              mm-button
              type="submit"
              [ngClass]="{
              'button-white': color === 'lightBlue',
              'button-blue': !color || color === 'white'
            }"
            >
              <span *ngIf="!isLoading">{{ 'HOME.HOME_PAGE.NEWSLETTER.BUTTONTEXT' | translate }}</span>
              <mm-icon name="check" *ngIf="isLoading"></mm-icon>
            </button>
          </div>
        </form>
        <p
          *ngIf="showLegalText"
          @showLegalText
          class="advanced-newsletter__form-content__legal-text"
          [ngClass]="{
          'text-primary-blue': !color || color === 'white',
          'text-white': color === 'lightBlue'
        }"
          [innerHTML]="
          getNewsletterContent(
            'HOME.HOME_PAGE.NEWSLETTER.LEGALTEXT' | translate,
            'HOME.HOME_PAGE.NEWSLETTER.PRIVACY_POLICY' | translate,
            'HOME.HOME_PAGE.NEWSLETTER.PROMO_TEXT' | translate,
            'HOME.HOME_PAGE.NEWSLETTER.PROMO_LINK_TEXT' | translate
          ) | sanitize
        "
        ></p>
      </ng-container>
    </div>
  </div>
</section>

<ng-template #submitConfirmationTemplate>
  <ng-container>
    <div class="advanced-newsletter__form-content__confirm">
      <p
        [ngClass]="{
          'text-primary-blue': !color || color === 'white',
          'text-white': color === 'lightBlue'
        }"
        class="advanced-newsletter__form-content__confirm__submit-text"
      >
        {{ 'HOME.HOME_PAGE.NEWSLETTER.CONFIRMATION_MESSAGE' | translate }}:
        <span>{{ form.value.email }}</span>
      </p>
      <p
        [ngClass]="{
          'text-primary-blue': !color || color === 'white',
          'text-white': color === 'lightBlue'
        }"
        class="advanced-newsletter__form-content__confirm__email-link"
      >
        <span>{{ 'CORE.ALL_PAGES.OTP_LOGIN.OTP_DIALOG.BODY_TEXT.EMAIL_NOT_SEND_TEXT' | translate }}</span>
        <a [ngClass]="{ 'link-text-contrast': color && color !== 'white' }" (click)="resendEmail()">{{
          'CORE.ALL_PAGES.OTP_LOGIN.OTP_DIALOG.BODY_TEXT.EMAIL.SEND_AGAIN' | translate
        }}</a>
        <mm-icon
          [ngClass]="{
            'text-primary-blue': !color || color === 'white',
            'text-white': color === 'lightBlue'
          }"
          name="check"
          *ngIf="resend"
        ></mm-icon>
      </p>
    </div>
  </ng-container>
</ng-template>
